// Scroll Animation
import initAnimacaoScroll from "./js/modules/animacao-scroll.js";
initAnimacaoScroll();

// Swiper JS
import "./js/modules/swiper.js";
import "./js/modules/accordion-img.js";
import "./js/modules/go-up.js";
import "./js/modules/features.js";
import "./js/modules/navbar.js";
import "./js/modules/contact.js";
